import React from "react";
import { Link } from "react-router-dom";
import moment from 'moment'
import Config from "./Config/Config";



const Footer = () => {
    return (
        <>
            <footer className="bgblack">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 logo-email">
                            <img
                                src="/images/logo.png"
                                alt="Buzzway Cab Services - Footer Logo"
                                title="Buzzway Cab Services"
                                loading="lazy"
                                width="200"
                                height="60"
                            />
                            <p style={{ color: 'white' }}>
                                Connect:
                                <a
                                    style={{ color: '#F4B045' }}
                                    href="mailto:booking@buzzway.in"
                                    aria-label="Email Buzzway at booking@buzzway.in"
                                >
                                    booking@buzzway.in
                                </a>
                            </p>
                        </div>
                        <div className="col-sm-7 footrmenu topMargin11x">
                            <ul className="row">
                                {/* <li><a href="/about-us">About Us</a></li> */}
                                <li className="col-sm-3"><Link to={`/about-us`}>About Us</Link></li>
                                <li className="col-sm-3"><Link to={`/contact-us`}>Contact Us</Link></li>
                                <li className="col-sm-2"><Link to={`/drive-with-us`}>Drivers</Link></li>
                                <li className="col-sm-3"><Link to={`/terms-conditions`}>Terms & Conditions</Link></li>
                            </ul>
                            <ul className="row">
                                {/* <li><a href="/about-us">About Us</a></li> */}
                                <li className="col-sm-3"><Link to={`/privacy-policy`}>Privacy Policy</Link></li>
                                <li className="col-sm-3"><Link to={`/refund-Policy`}>Refund Policy</Link></li>
                                <li className="col-sm-2"><Link to={`/blogs`}>Blogs</Link></li>
                                <li className="col-sm-3"><a href={`/sitemap.xml`}>Site Map</a></li>
                            </ul>
                        </div>
                        <div className="col-sm-2 social topMargin11x">
                            <ul>
                                <li> <a
                                    href="https://www.facebook.com/buzzway01/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    aria-label="Follow Buzzway on Facebook"
                                    title="Follow Buzzway on Facebook"

                                >
                                    <img
                                        src={'images/facebook.svg'}
                                        alt="Follow Buzzway on Facebook"
                                        title="Follow Buzzway on Facebook"
                                        width={35} height={35}
                                        style={{ width: "revert-layer", height: "auto" }}
                                    />
                                </a> </li>
                                <li> <a
                                    href="https://www.instagram.com/buzzwaytaxiservice/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    aria-label="Follow Buzzway on Instagram"
                                    title="Follow Buzzway on Instagram"
                                ><img
                                        src={'/images/insta.svg'}
                                        alt="Follow Buzzway on Instagram"
                                        title="Follow Buzzway on Instagram"
                                        width={35} height={35}
                                        style={{ width: "revert-layer", height: "auto" }}
                                    /> </a> </li>
                                <li> <a
                                    href="https://twitter.com/buzzway01/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    aria-label="Follow Buzzway on Twitter"
                                    title="Follow Buzzway on Twitter"
                                ><img
                                        src={'/images/twitter.svg'}
                                        alt="Follow Buzzway on Twitter"
                                        title="Follow Buzzway on Twitter"
                                        width={35} height={35}
                                        style={{ width: "revert-layer", height: "auto" }}
                                    /> </a> </li>
                                <li> <a
                                    href="https://www.youtube.com/channel/UCmk1a_siIybosrgdJrHCcww"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    aria-label="Follow Buzzway on YouTube"
                                    title="Follow Buzzway on YouTube"
                                ><img
                                        src={"/images/yt.svg"}
                                        alt="Follow Buzzway on YouTube"
                                        title="Follow Buzzway on YouTube"
                                        width={35} height={35}
                                        style={{ width: "revert-layer", height: "auto" }}

                                    /> </a> </li>
                            </ul>
                        </div>
                    </div>
                    {/* <div className="row footrmenu">
                        <ul>
                            <li><Link to={`/about-us`}>About Us</Link></li>
                            <li><Link to={`/contact-us`}>Contact Us</Link></li>
                            <li><Link to={`/register`}>Drivers</Link></li>
                            <li><Link to={`/terms-conditions`}>Terms & Conditions</Link></li>
                            <li><Link to={`/privacy-policy`}>Privacy Policy</Link></li>
                            <li><Link to={`/refund-Policy`}>Refund Policy</Link></li>
                            <li><Link to={`/blogs`}>Blogs</Link></li>
                            <li><a href={`/sitemap.xml`}>Site Map</a></li>
                        </ul>
                    </div> */}
                    <div className="row">
                        <div className="copyr">
                            <p>
                                <img
                                    src="/images/copyright-line.svg"
                                    alt="Copyright Icon"
                                    title="Copyright"
                                    loading="lazy"
                                    width={17} height={17}
                                    style={{ width: "revert-layer", height: "auto", verticalAlign: 'middle', marginRight: '5px' }}
                                />
                                {moment().year()} | All Rights Reserved by Buzzway.
                                Promoted and Designed by {" "}
                                <a
                                    style={{ color: '#F4B045' }}
                                    href="https://www.duplextech.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Visit Duplex Technologies Website"
                                >
                                    Duplex Technologies
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="mx-0 callbknow footer_fixed">
                    <div class="hdrbtn fttrbtn">
                       <a href="tel:+91-9054865866" class="sitehdrbtn">Call +91-9054865866</a>
                    </div>
                    <div class="fttrwtsp_btn">
                        <a href="https://wa.me/919054865866" class="cbntxt">
                            <img src="/static/media/whatsapp.ee60bfac4c0ac027d77fbe6f8fee425b.svg" alt="what app images" title="what app images" loading="lazy" />
                        </a>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer; 